import React from "react";
import { Check } from "lucide-react";
import { GAME_TYPES, SEALED_NO, fileNo, verdictLabel } from "../data/sporeGames";

export const ScientistCard = ({ doctor, entry, record, index, onOpen }) => {
  const type = GAME_TYPES[entry.game];
  return (
    <button
      type="button"
      data-testid={`scientist-card-${doctor.id}`}
      data-status={record ? "revealed" : "sealed"}
      onClick={onOpen}
      style={{ animationDelay: `${Math.min(index, 16) * 35}ms` }}
      className="spore-fade-up group text-left rounded-sm border border-slate-800 bg-[#121824] overflow-hidden flex flex-col transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-cyan-500/50 hover:shadow-[0_0_18px_rgba(0,245,255,0.15)] focus:outline-none focus:ring-2 focus:ring-cyan-400"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={doctor.image}
          alt={doctor.name}
          loading="lazy"
          className="w-full h-full object-cover object-top grayscale contrast-125 transition-[filter,transform] duration-500 group-hover:grayscale-[30%] group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121824] via-[#121824]/10 to-transparent" />
        <span className={`absolute top-3 left-3 font-tac text-[10px] tracking-widest px-2 py-1 border rounded-sm ${type.badge}`}>
          {type.name.toUpperCase()}
        </span>
        {record && (
          <span
            data-testid={`scientist-verdict-${doctor.id}`}
            data-verdict={entry.infected ? "infected" : "clear"}
            className={`absolute bottom-3 left-3 font-tac text-[11px] font-bold tracking-widest px-2 py-1 rounded-sm text-black ${entry.infected ? "bg-[#FF2E63]" : "bg-emerald-400"}`}
          >
            {verdictLabel(entry)}
          </span>
        )}
        {record ? (
          <span data-testid={`scientist-tick-${doctor.id}`} className="absolute top-3 right-3 bg-emerald-400 text-black rounded-full p-1 shadow-[0_0_14px_rgba(16,185,129,0.6)]">
            <Check className="h-4 w-4" strokeWidth={3} />
          </span>
        ) : (
          <span className="absolute top-3 right-3 font-tac text-[10px] tracking-widest text-red-300 border border-red-500/60 bg-red-950/80 px-2 py-1 spore-stamp">
            SEALED
          </span>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col gap-1.5">
        <p className="font-display font-bold text-lg leading-tight text-slate-100">{doctor.name}</p>
        <p className="font-tac text-[11px] text-slate-500 uppercase tracking-wider">{doctor.nationality}</p>
        <p className="text-sm text-slate-400 line-clamp-2 mt-1">{doctor.specialization}</p>
        <div className="mt-auto pt-3 border-t border-slate-800 flex items-center justify-between gap-3 font-tac text-xs">
          <span className="text-cyan-300/80 shrink-0">{record ? fileNo(entry) : SEALED_NO}</span>
          {record ? (
            <span data-testid={`scientist-symptom-${doctor.id}`} className={`font-bold uppercase truncate ${entry.infected ? "text-[#FF2E63]" : "text-emerald-400"}`}>{entry.symptom}</span>
          ) : (
            <span className="text-slate-600 tracking-widest truncate">▒▒▒▒▒▒▒▒▒</span>
          )}
        </div>
      </div>
    </button>
  );
};
